import { render } from "./service-agreement.vue?vue&type=template&id=59495d41&scoped=true"
const script = {}

import "./service-agreement.vue?vue&type=style&index=0&id=59495d41&scoped=true&lang=css"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59495d41"]])

export default __exports__